/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PlannerActiveTurnResponse } from './PlannerActiveTurnResponse';
import {
    PlannerActiveTurnResponseFromJSON,
    PlannerActiveTurnResponseFromJSONTyped,
    PlannerActiveTurnResponseToJSON,
    PlannerActiveTurnResponseToJSONTyped,
} from './PlannerActiveTurnResponse';
import type { PlannerMessageResponse } from './PlannerMessageResponse';
import {
    PlannerMessageResponseFromJSON,
    PlannerMessageResponseFromJSONTyped,
    PlannerMessageResponseToJSON,
    PlannerMessageResponseToJSONTyped,
} from './PlannerMessageResponse';
import type { PlannerSessionResponse } from './PlannerSessionResponse';
import {
    PlannerSessionResponseFromJSON,
    PlannerSessionResponseFromJSONTyped,
    PlannerSessionResponseToJSON,
    PlannerSessionResponseToJSONTyped,
} from './PlannerSessionResponse';

/**
 * 
 * @export
 * @interface PlannerSessionDetailResponse
 */
export interface PlannerSessionDetailResponse {
    /**
     * 
     * @type {PlannerSessionResponse}
     * @memberof PlannerSessionDetailResponse
     */
    session: PlannerSessionResponse;
    /**
     * 
     * @type {Array<PlannerMessageResponse>}
     * @memberof PlannerSessionDetailResponse
     */
    messages: Array<PlannerMessageResponse>;
    /**
     * 
     * @type {number}
     * @memberof PlannerSessionDetailResponse
     */
    latestEventSequence: number;
    /**
     * 
     * @type {PlannerActiveTurnResponse}
     * @memberof PlannerSessionDetailResponse
     */
    activeTurn?: PlannerActiveTurnResponse | null;
}

/**
 * Check if a given object implements the PlannerSessionDetailResponse interface.
 */
export function instanceOfPlannerSessionDetailResponse(value: object): value is PlannerSessionDetailResponse {
    if (!('session' in value) || value['session'] === undefined) return false;
    if (!('messages' in value) || value['messages'] === undefined) return false;
    if (!('latestEventSequence' in value) || value['latestEventSequence'] === undefined) return false;
    return true;
}

export function PlannerSessionDetailResponseFromJSON(json: any): PlannerSessionDetailResponse {
    return PlannerSessionDetailResponseFromJSONTyped(json, false);
}

export function PlannerSessionDetailResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PlannerSessionDetailResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'session': PlannerSessionResponseFromJSON(json['session']),
        'messages': ((json['messages'] as Array<any>).map(PlannerMessageResponseFromJSON)),
        'latestEventSequence': json['latest_event_sequence'],
        'activeTurn': json['active_turn'] == null ? undefined : PlannerActiveTurnResponseFromJSON(json['active_turn']),
    };
}

export function PlannerSessionDetailResponseToJSON(json: any): PlannerSessionDetailResponse {
    return PlannerSessionDetailResponseToJSONTyped(json, false);
}

export function PlannerSessionDetailResponseToJSONTyped(value?: PlannerSessionDetailResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'session': PlannerSessionResponseToJSON(value['session']),
        'messages': ((value['messages'] as Array<any>).map(PlannerMessageResponseToJSON)),
        'latest_event_sequence': value['latestEventSequence'],
        'active_turn': PlannerActiveTurnResponseToJSON(value['activeTurn']),
    };
}

